import { useTranslation } from "next-i18next";
// BOOTSTRAP
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
// STYLE
import s from "./InputWithButtons.module.scss";

interface InputWithButtonsProps {
  actionButtonNumber?: number;
  variant: string;
  cartMode: boolean;
  handleDisabled: boolean;
  disableForm: boolean;
  index: string;
  onChangeQuantity: any;
  quantityPerSize: any;
  selectedColor: string;
  selectedSize: string;
}

export default function InputWithButtons({
  actionButtonNumber = 1,
  variant,
  cartMode,
  handleDisabled,
  disableForm,
  index,
  onChangeQuantity,
  quantityPerSize,
  selectedColor,
  selectedSize,
}: InputWithButtonsProps) {
  const { t } = useTranslation(["common"]);
  
  // Retrieve data from quantityPerSize state, if selectedColor and selectedSize equals this color and size the
  // content will be retrieved. If there's no match shown quantity will be 0.
  let currentCartQuantity =
    quantityPerSize?.filter((qs) => {
      return qs.color === selectedColor && qs.size === selectedSize;
    })[0]?.quantity ?? 0;

  //  Check type of action and dispatch an action. if the action is an object the value will replace the original value.
  // If action is "+1", this will be added to original value, if action is "-1", this will be detracted from original value.

  // When in Presale page, action must be a multiple of the product package. Package must be passed as a props.
  const handleChange = (action: any) => {
    let updatedQuantity = 0;
    if (typeof action === "number") {
      updatedQuantity = parseInt(currentCartQuantity) + (isNaN(action) ? 0 : action);
    } else {
      updatedQuantity = parseInt(action.value === "" ? 0 : action.value);
    }
    if (updatedQuantity < 0 || (cartMode && updatedQuantity < 1)) {
      onChangeQuantity({ quantity: currentCartQuantity, size: selectedSize });
    } else {
      onChangeQuantity({ quantity: updatedQuantity, size: selectedSize });
    }
  };

  // If a value is 0, when onFocus in input the value will be selected, so user can overwrite it easily
  const handleFocus = (e) => {
    if (e.target.value == 0) {
      e.currentTarget.select();
    }
  };

  const customButtonClass = cartMode ? s.input_button_cart : s.input_button;
  const customFormClass = cartMode ? s.item_quantity_input_cart : s.item_quantity_input;

  return handleDisabled && !cartMode ? (
    <OverlayTrigger placement="top" overlay={<Tooltip id={`${index}-form`}>{t("common.select-color")}</Tooltip>} key={index}>
      <div className="d-flex">
        <Button
          style={{ pointerEvents: handleDisabled ? "none" : "auto" }}
          disabled={handleDisabled}
          variant={variant}
          className={`${customButtonClass}`}
          onClick={() => {
            handleChange(-actionButtonNumber);
          }}
        >
          <span className="fs-4 fw-medium">-</span>
        </Button>
        <Form.Control
          disabled={handleDisabled || disableForm}
          placeholder="0"
          type="text"
          inputMode="numeric"
          id={`input-${selectedSize}`}
          className={`${customFormClass}`}
          name={`${selectedSize}`}
          onFocus={handleFocus}
          onChange={(e) => {
            if (!isNaN(Number(e.target.value))) handleChange(e.currentTarget);
          }}
          value={currentCartQuantity === 0 ? "" : currentCartQuantity}
        />

        <Button
          style={{ pointerEvents: handleDisabled ? "none" : "auto" }}
          disabled={handleDisabled}
          variant={variant}
          className={`${customButtonClass} d-flex align-items-center`}
          onClick={() => {
            handleChange(+actionButtonNumber);
          }}
        >
          <span className="fs-4 fw-medium">+</span>
        </Button>
      </div>
    </OverlayTrigger>
  ) : (
    <div className="d-flex">
      <Button
        style={{ pointerEvents: handleDisabled ? "none" : "auto" }}
        disabled={handleDisabled}
        variant={variant}
        className={`${customButtonClass}  d-flex align-items-center`}
        onClick={() => {
          handleChange(-actionButtonNumber);
        }}
      >
        <span className="fs-4 fw-medium">-</span>
      </Button>
      <Form.Control
        disabled={handleDisabled || disableForm}
        placeholder="0"
        type="text"
        inputMode="numeric"
        id={`input-${selectedSize}`}
        className={`${customFormClass}`}
        name={`${selectedSize}`}
        onFocus={handleFocus}
        onChange={(e) => {
          if (!isNaN(Number(e.target.value))) handleChange(e.currentTarget);
        }}
        value={currentCartQuantity === 0 ? "" : currentCartQuantity}
      />

      <Button
        style={{ pointerEvents: handleDisabled ? "none" : "auto" }}
        disabled={handleDisabled}
        variant={variant}
        className={`${customButtonClass}  d-flex align-items-center`}
        onClick={() => {
          handleChange(+actionButtonNumber);
        }}
      >
        <span className="fs-4 fw-medium">+</span>
      </Button>
    </div>
  );
}
